export const SYNC_INTERVAL_IN_SECONDS = 120;

export const ERROR_MESSAGE_TIMEOUT_MS = 3000;

export const DEBOUNCE_TIMEOUT_MS = 3000;

export const SCHEDULE_WINDOW_DAYS = 6;

export const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const LOW_STOCK_THRESHOLD = 8;
